import * as React from "react";
import { CmsHeadTags, CmsContainerPage, CmsPageLayout } from "@grandvisionhq/bloomreach";
import { ErrorPage } from "@grandvisionhq/layout";
import { useTrackErrorPageView } from "@grandvisionhq/svc-tealium/hooks";
const ErrorPageComponent = (props) => {
  const { buttonText, image, subheader, title, statusCode } = props;
  useTrackErrorPageView({ statusCode });
  if (statusCode === 404) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CmsHeadTags, { title, noIndex: true, noFollow: true }), /* @__PURE__ */ React.createElement(CmsContainerPage, null, /* @__PURE__ */ React.createElement(CmsPageLayout, null, /* @__PURE__ */ React.createElement(ErrorPage, { header: title, buttonText, image, subheader }))));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CmsHeadTags, { title, noIndex: true, noFollow: true }), /* @__PURE__ */ React.createElement(ErrorPage, { header: title, buttonText, image, subheader }));
};
const withErrorPage = (errorProps) => (PageComponent) => {
  const WithErrorPage = (props) => {
    const { statusCode } = props;
    if (statusCode && statusCode >= 400) {
      return /* @__PURE__ */ React.createElement(ErrorPageComponent, { ...props, statusCode });
    }
    return /* @__PURE__ */ React.createElement(PageComponent, { ...props });
  };
  WithErrorPage.getInitialProps = async (ctx) => {
    const pageProps = (PageComponent.getInitialProps ? await PageComponent.getInitialProps(ctx) : null) || {};
    if (pageProps.statusCode && ctx.res) {
      ctx.res.statusCode = pageProps.statusCode;
    }
    const extractedLocale = ctx.req?.locale.toString();
    if (extractedLocale && errorProps?.[extractedLocale]) {
      return {
        ...pageProps,
        ...errorProps[extractedLocale]
      };
    } else if (errorProps) {
      return {
        ...pageProps,
        ...errorProps
      };
    }
    return pageProps;
  };
  WithErrorPage.displayName = `WithErrorPage(${PageComponent.displayName || PageComponent.name || "Unknown"})`;
  return WithErrorPage;
};
export {
  withErrorPage as default
};
//# sourceMappingURL=with-error-page.js.map
